export var NavigationTestIds;
(function (NavigationTestIds) {
    NavigationTestIds["LOGO_ICON_CONTAINER"] = "hawkins-app-logo-icon-container";
    NavigationTestIds["LOGO_BETA_ICON_CONTAINER"] = "hawkins-app-logo-beta-icon-container";
    NavigationTestIds["LOGO_APP_NAME"] = "hawkins-app-logo-app-name";
})(NavigationTestIds || (NavigationTestIds = {}));
export var HorizontalNavigationTestIds = {
    /** Test ID of the root element. */
    ROOT: 'hawkins-horizontal-navigation-root',
};
export var VerticalNavigationTestIds = {
    /** Test ID of the root element. */
    ROOT: 'hawkins-vertical-navigation-root',
    /** Test ID of the main content container element. */
    MAIN_CONTENT: 'hawkins-vertical-navigation-main-content',
};
